
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetInvoiceCategoriesQuery } from "../../../../../newapi/financial/invoiceCategorySlice";
import { general_states } from "../../../../../utils/staticEnums";

import { WarehouseInvoiceCategoryCard } from "../../../../../components/global/cards/financial/InvoiceCategoryCard";
import MAddInvoiceCategory from "../../../../../components/global/Modals/MAddInvoiceCategory";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../utils/permissions";
import { useSelector } from "react-redux";

const SpInvoiceCategoryDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpInvoiceCategoryDetails/SpInvoiceCategoryDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return props.hasCreatePrivilege ?
        <ButtonGroup version={2}>
            <Shbutton 
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                onClick={() => props.handleOpen(true)}
                endIcon={<AddIcon/>}
                variant="contained"
            >
                {t('new_category')}
            </Shbutton>
        </ButtonGroup>
        : <></>;
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,

};

const Categories = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const hasCreatePrivilege = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.INVOICECATEGORY_MANAGE])
    );
    
    const ref = useRef();
    const [config, setConfig] = useState({"state": general_states.ACTIVE});

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
        }
    },[props.config]);

    const handleOpen = () => {
        setAddModalOpen(true);
    }
    
    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
    };

    const [invoiceCategoryId, setInvoiceCategoryId] = useState();
    const invoiceCategoryIdRef = useRef(invoiceCategoryId);
    
    const getInvoiceCategory = (params) => {
        if (!params) return;
    
        const newInvoiceCategoryId = parseInt(params.row.id);
        // Only update state if the pickingJobListId has actually changed
        if (invoiceCategoryIdRef.current !== newInvoiceCategoryId) {
            
            if(!spLoading) {
                setSpLoading(true);
            }
            setInvoiceCategoryId(newInvoiceCategoryId);
            invoiceCategoryIdRef.current = newInvoiceCategoryId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const columns = [
        {
            field: "name",
            headerName: t("name"),
            flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
    
                return params.row.name;
            }
        },
        {field: "relations", headerName: t("relations"),flex:1,
            sortable:false,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.row.relations ? params.row.relations.length : 0;
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <WarehouseInvoiceCategoryCard
                        onClick={() => getInvoiceCategory(params)}
                        skeleton={params.row.skeleton}
                        {...params.row}
                    />
                    // <ShTextSkeleton/>
                )
            }
        }
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetInvoiceCategoriesQuery}
                config={config}
                gridActions={<GridActions handleOpen={handleOpen} hasCreatePrivilege={hasCreatePrivilege}></GridActions>} 
                title={t('categories')}
                gridOptions={gridOptions} 
                columns={columns}
                rows={data}
                onRowClick={getInvoiceCategory}
                sortModel={{field: columns[0].field,type:"ASC"}}
                >
            </ShDataGrid2>

            {spLoading && 
                    <SpInvoiceCategoryDetails
                        invoiceCategoryId={invoiceCategoryId}
                        isExtended={isExtended}
                        setIsExtended={setIsExtended}
                        // data={pickingJobData}
                    /> 
            }


            <MAddInvoiceCategory onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose} />
        </Box>
    );
}

export default Categories;